import { Box, Paper, Typography, Button } from '@mui/material'
import { Home, ArrowBack } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
    const navigate = useNavigate()

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #1a3a6b 0%, #c9a227 100%)',
                p: 3,
            }}
        >
            <Paper
                sx={{
                    p: 4,
                    maxWidth: 500,
                    textAlign: 'center',
                    borderRadius: 3,
                }}
            >
                <Typography
                    variant="h1"
                    sx={{
                        fontSize: '8rem',
                        fontWeight: 700,
                        background: 'linear-gradient(135deg, #1a3a6b 0%, #c9a227 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}
                >
                    404
                </Typography>
                <Typography variant="h5" gutterBottom>
                    Page Not Found
                </Typography>
                <Typography color="text.secondary" sx={{ mb: 4 }}>
                    The page you're looking for doesn't exist or has been moved.
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                    <Button
                        variant="outlined"
                        startIcon={<ArrowBack />}
                        onClick={() => navigate(-1)}
                    >
                        Go Back
                    </Button>
                    <Button
                        variant="contained"
                        startIcon={<Home />}
                        onClick={() => navigate('/')}
                        sx={{
                            background: 'linear-gradient(135deg, #1a3a6b 0%, #c9a227 100%)',
                        }}
                    >
                        Go Home
                    </Button>
                </Box>
            </Paper>
        </Box>
    )
}

export default NotFound
